import "./pt-logic-connector.css"
import model from "../../prototypes/VALUE_BOOLEAN"
import parseBoolean from "./config/parseBoolean"
import { getModelFromInput } from '../../common/getModelFunctions';

export default {
	model,
	computed: {
		value() {
			const input = this.$el.dataset.inputs;

			return parseBoolean(getModelFromInput(input, this.$model));
		}
	},
	listeners: {
		click: true
	}
};
